import { startStateName } from './components/start/start.state';

import { legalStateName } from './components/legal/legal.state';

import { changelogStateName } from './components/changelog/changelog.state';

export const HIDDEN_HEADER_STATES = [
  startStateName,
  legalStateName,
  changelogStateName,
];



// WEBPACK FOOTER //
// ./src/app/app.constants.js